import { Link } from '@inertiajs/react'

export default function NotFound() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100svh',
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
        <div>
          NOT FOUND
        </div>
        <Link href="/" style={{
          color: 'blue',
          textDecoration: 'underline',
        }}>
          Go Home &gt;
        </Link>
      </div>
    </div>
  )
}
